import { useEffect, useState } from "react";

const VendorDetails = ({ formData, setFormData, onSave }) => {
  // const [formData, setDetails] = useState(formData);

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  // useEffect(() => {
  //   onSave(formData);
  // }, [onSave]);

  return (
    <div className="grid grid-cols-2 gap-4">
      {/* Vendor Details */}
      <div>
        <label className="block mb-1 font-medium">Vendor Name*</label>
        <input
          type="text"
          name="vendor_name"
          value={formData.vendor_name}
          onChange={handleChange}
          className="w-full border border-[#d8d8d8] p-2 rounded"
        />
      </div>
      <div>
        <label className="block mb-1 font-medium">Vendor Code*</label>
        <input
          type="text"
          name="vendor_code"
          value={formData.vendor_code}
          onChange={handleChange}
          className="w-full border border-[#d8d8d8] p-2 rounded"
        />
      </div>
      <div>
        <label className="block mb-1 font-medium">Type*</label>
        <select
          name="type"
          value={formData.type}
          onChange={handleChange}
          className="w-full border border-[#d8d8d8] p-2 rounded"
        >
          <option value="Manufacturer">Manufacturer</option>
          <option value="Distributor">Distributor</option>
          <option value="Retailer">Retailer</option>
          <option value="Service Provider">Service Provider</option>
        </select>
      </div>
      <div>
        <label className="block mb-1 font-medium">GSTIN*</label>
        <input
          type="text"
          name="gstin"
          value={formData.gstin}
          onChange={handleChange}
          className="w-full border border-[#d8d8d8] p-2 rounded"
        />
      </div>
      <div>
        <label className="block mb-1 font-medium">PAN*</label>
        <input
          type="text"
          name="pan"
          value={formData.pan}
          onChange={handleChange}
          className="w-full border border-[#d8d8d8] p-2 rounded"
        />
      </div>
      <div>
        <label className="block mb-1 font-medium">TIN</label>
        <input
          type="text"
          name="tin"
          value={formData.tin}
          onChange={handleChange}
          className="w-full border border-[#d8d8d8] p-2 rounded"
        />
      </div>
      <div>
        <label className="block mb-1 font-medium">CIN</label>
        <input
          type="text"
          name="cin"
          value={formData.cin}
          onChange={handleChange}
          className="w-full border border-[#d8d8d8] p-2 rounded"
        />
      </div>
      <div>
        <label className="block mb-1 font-medium">TAN</label>
        <input
          type="text"
          name="tan"
          value={formData.tan}
          onChange={handleChange}
          className="w-full border border-[#d8d8d8] p-2 rounded"
        />
      </div>
      <div>
        <label className="block mb-1 font-medium">MSME</label>
        <input
          type="text"
          name="msme"
          value={formData.msme}
          onChange={handleChange}
          className="w-full border border-[#d8d8d8] p-2 rounded"
        />
      </div>

      {/* Contact Details */}
      <div>
        <label className="block mb-1 font-medium">Contact Person Name*</label>
        <input
          type="text"
          name="contact_person_name"
          value={formData.contact_person_name}
          onChange={handleChange}
          className="w-full border border-[#d8d8d8] p-2 rounded"
        />
      </div>
      <div>
        <label className="block mb-1 font-medium">Contact Email*</label>
        <input
          type="email"
          name="contact_email"
          value={formData.contact_email}
          onChange={handleChange}
          className="w-full border border-[#d8d8d8] p-2 rounded"
        />
      </div>
      <div>
        <label className="block mb-1 font-medium">Contact Phone*</label>
        <input
          type="text"
          name="contact_phone"
          value={formData.contact_phone}
          onChange={handleChange}
          className="w-full border border-[#d8d8d8] p-2 rounded"
        />
      </div>
      <div>
        <label className="block mb-1 font-medium">Alternate Phone</label>
        <input
          type="text"
          name="alternate_phone"
          value={formData.alternate_phone}
          onChange={handleChange}
          className="w-full border border-[#d8d8d8] p-2 rounded"
        />
      </div>

      {/* Addresses */}
      <div>
        <label className="block mb-1 font-medium">Registered Address*</label>
        <textarea
          name="registered_address"
          value={formData.registered_address}
          onChange={handleChange}
          className="w-full border border-[#d8d8d8] p-2 rounded"
          rows="3"
        />
      </div>
      <div>
        <label className="block mb-1 font-medium">Communication Address</label>
        <textarea
          name="communication_address"
          value={formData.communication_address}
          onChange={handleChange}
          className="w-full border border-[#d8d8d8] p-2 rounded"
          rows="3"
        />
      </div>

      {/* Bank Details */}
      <div>
        <label className="block mb-1 font-medium">Account Number</label>
        <input
          type="text"
          name="account_number"
          value={formData.account_number}
          onChange={handleChange}
          className="w-full border border-[#d8d8d8] p-2 rounded"
        />
      </div>
      <div>
        <label className="block mb-1 font-medium">IFSC Code</label>
        <input
          type="text"
          name="ifsc"
          value={formData.ifsc}
          onChange={handleChange}
          className="w-full border border-[#d8d8d8] p-2 rounded"
        />
      </div>
      <div>
        <label className="block mb-1 font-medium">Bank Name</label>
        <input
          type="text"
          name="bank_name"
          value={formData.bank_name}
          onChange={handleChange}
          className="w-full border border-[#d8d8d8] p-2 rounded"
        />
      </div>
      <div>
        <label className="block mb-1 font-medium">Branch</label>
        <input
          type="text"
          name="branch_name"
          value={formData.branch_name}
          onChange={handleChange}
          className="w-full border border-[#d8d8d8] p-2 rounded"
        />
      </div>

      {/* Notes */}
      <div className="col-span-2">
        <label className="block mb-1 font-medium">Notes</label>
        <textarea
          name="notes"
          value={formData.notes}
          onChange={handleChange}
          className="w-full border border-[#d8d8d8] p-2 rounded"
          rows="3"
        />
      </div>
    </div>
  );
};

export default VendorDetails;
